module.exports = __webpack_public_path__ + "img/Fiche chargé organisation grands évènements.4c49e75a.jpg";